import React from 'react';

/**
 * Outline building glyph, inlined verbatim from the Figma Activity "Building"
 * icon (file 4FpcyaiutzOU5WsPhYu6DG). Inlined rather than <img> so it stays
 * crisp at any size — the exported SVG carries width/height="100%" +
 * preserveAspectRatio="none", which stretch and blur in a fixed-size box.
 *
 * The 32x32 width/height keep the default (ActivityView) render identical; a
 * passed `className` with CSS width/height overrides them (CSS beats SVG
 * presentation attributes) so callers can size the vector without blur.
 */
const BuildingGlyph = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 32 32"
    width="32"
    height="32"
    fill="none"
    aria-hidden="true"
  >
    <g opacity="0.8" fill="#131c20">
      <path d="M13.6667 18.6667H11V16H13.6667V18.6667Z" />
      <path d="M21 18.6667H18.3333V16H21V18.6667Z" />
      <path d="M13.6667 12H11V9.33333H13.6667V12Z" />
      <path d="M21 12H18.3333V9.33333H21V12Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6667 2.66667C25.6122 2.66667 28 5.05448 28 8V30.6667H4V8C4 5.05448 6.38781 2.66667 9.33333 2.66667H22.6667ZM9.33333 5.33333C7.86057 5.33333 6.66667 6.52724 6.66667 8V28H14.6667V24H17.3333V28H25.3333V8C25.3333 6.52724 24.1394 5.33333 22.6667 5.33333H9.33333Z"
      />
    </g>
  </svg>
);

export default BuildingGlyph;
